export const RECOVERY_CATEGORY = "password_recovery";
